import { ENV } from "shared-tsi";
import { environmentBase } from "./environment.base";

export const environment = {
    ...environmentBase,
    production: false,
    name: ENV.DEV,
    apiService_Auth: '/backend-login',
    apiService: '/backend-soporte',
    apiService_CRM: '/backend-crm',
    apiService_Erp: '/backend-api',
    apiService_Report: '/backend-report',
    apiService_Export: '/backend-export',
    apiService_Produccion: '/backend-prod-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_Ia: '/backend-ia',
    apiService_Rewriter: '/backend-rewriter',
    apiService_FE: '/backend-fe',
    apiService_Notificaciones: '/backend-notification',
    apiService_Config: '/backend-config',
    apiService_Planilla: '/backend-planilla',
    apiService_Etiquetas: '/backend-etiquetas',
    apiService_Formula: '/formula-explainer',
    apiService_Scrap: '/backend-scrap',
    apiService_Asistencia: '/backend-asistencia',
    recaptcha: {
        siteKey: '6Ld4ZT0sAAAAAG9XH7-7d4s_0EAIToZXpeeCJGO5',
    }
}